import { diffStateSamples } from "./diffStateSamples"
import {
  AccountHealth,
  AccountStateSample,
  ExpectedAccountState,
  ObservedAccountState,
  UNKNOWN,
} from "./testAccountHealth.types"

const expectationMet = (
  expectedValue: ExpectedAccountState[keyof ExpectedAccountState],
  observed: ObservedAccountState[keyof ObservedAccountState],
): boolean =>
  Array.isArray(expectedValue)
    ? expectedValue.includes(observed as string)
    : observed === expectedValue

export const evaluateHealth = (
  expected: ExpectedAccountState,
  samples: AccountStateSample[],
): AccountHealth => {
  const errors = [...new Set(samples.flatMap((s) => s.errors))]

  const flappingFields = [
    ...new Set(
      samples
        .slice(1)
        .flatMap((s, i) => diffStateSamples(samples[i].state, s.state)),
    ),
  ].sort()

  const cleanSamples = samples.filter((s) => s.errors.length === 0)
  const reference =
    cleanSamples[cleanSamples.length - 1] ?? samples[samples.length - 1]
  const driftedFields = reference
    ? (Object.keys(expected) as Array<keyof ExpectedAccountState>)
        .filter((key) => {
          const observed = reference.state[key]
          return (
            observed !== UNKNOWN && !expectationMet(expected[key], observed)
          )
        })
        .map(String)
        .sort()
    : []

  const verdict = errors.length
    ? "ERROR"
    : flappingFields.length
      ? "FLAPPING"
      : driftedFields.length
        ? "DRIFTED"
        : "OK"

  return { verdict, driftedFields, flappingFields, errors }
}
